import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import SEO from '@/components/feature/SEO';
import SchemaOrg from '@/components/feature/SchemaOrg';
import HeroBanner from './components/HeroBanner';
import CategorySection from './components/CategorySection';
import HotRecommend from './components/HotRecommend';
import LatestArticles from './components/LatestArticles';
import FAQ from './components/FAQ';
import { faqData } from '@/mocks/anime';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [location.pathname]);

  return (
    <main>
      <SEO
        title="51动漫官网 - 51动漫网与51动漫网站国产精品入口 | 动漫主页官方直达"
        description="51动漫官网提供51动漫网、51动漫网站等国产精品入口，动漫爱好者可直接访问官方主页，快速进入51动漫平台观看热门动漫资源。涵盖热血战斗、玄幻修仙、搞笑日常、科幻机甲等全类型国产动漫资讯与深度解析。"
        keywords="51动漫官网,51动漫,51动漫网,51动漫网站,51动漫国产精品入口,动漫入口,动漫主页,51动漫官方"
        canonicalUrl="https://www.51anime.com/"
      />

      <SchemaOrg type="WebSite" data={{
        name: '51动漫官网',
        url: 'https://www.51anime.com/',
        description: '51动漫官网提供51动漫网、51动漫网站等国产精品入口，国产动漫爱好者的一站式内容平台。',
        potentialAction: {
          '@type': 'SearchAction',
          target: 'https://www.51anime.com/search?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      }} />

      <SchemaOrg type="Organization" data={{
        name: '51动漫官网',
        url: 'https://www.51anime.com/',
        description: '专注于国产动漫的综合性内容平台',
        sameAs: [
          'https://space.bilibili.com/51anime',
        ],
      }} />

      <SchemaOrg type="WebPage" data={{
        name: '51动漫官网首页',
        description: '51动漫官网 - 国产动漫精品入口主页',
        url: 'https://www.51anime.com/',
        isPartOf: { '@type': 'WebSite', name: '51动漫官网', url: 'https://www.51anime.com/' },
      }} />

      <SchemaOrg type="FAQPage" data={{
        mainEntity: faqData.map((item) => ({
          '@type': 'Question',
          name: item.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: item.answer,
          },
        })),
      }} />

      <HeroBanner />
      <CategorySection />
      <HotRecommend />
      <LatestArticles />
      <FAQ />
    </main>
  );
}